import React from 'react';
import { EstimationWizard } from '../components/estimation-wizard';
import { Navbar } from '../components/navbar';
import { Sidebar } from '../components/sidebar';

const EcoWizardPage: React.FC = () => {
  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Navbar />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200 p-6">
          <EstimationWizard />
        </main>
      </div>
    </div>
  );
};

export default EcoWizardPage;
